import React from 'react';
import styled from 'styled-components';
import CollectionsSection from '../components/CollectionsSection';

const PageContainer = styled.div`
  padding-top: var(--header-h); /* Header yüksekliği kadar boşluk */
  min-height: 100vh;
`;

const CollectionsPage: React.FC = () => {
  return (
    <PageContainer>
      <CollectionsSection />
    </PageContainer>
  );
};

export default CollectionsPage;
